'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StoredArray = exports.Storage = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** an abstraction around client-side storage, whether thats localStorage, Cookies, or Firebase, doesnt matter **/
var Cookies = require('js-cookie');
var merge = require('lodash/merge');

var Storage = function () {
    function Storage() {
        (0, _classCallCheck3.default)(this, Storage);
    }

    (0, _createClass3.default)(Storage, null, [{
        key: 'get',
        value: function get(k) {
            var asJSON = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return asJSON ? Cookies.getJSON(k) : Cookies.get(k);
        }
    }, {
        key: 'set',
        value: function set(k, v) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { expires: 7 };

            Cookies.set(k, v, options);
        }
    }, {
        key: 'remove',
        value: function remove(k) {
            Cookies.remove(k);
        }
    }]);
    return Storage;
}();

// a storage-backed array. Meaning, the state of the array is backed by storage and persisted


var StoredArray = function () {
    function StoredArray(props) {
        (0, _classCallCheck3.default)(this, StoredArray);

        var options = { key: null, ttl: 2 };

        merge(options, props);

        this.key = options.key; // the unique identifier for this stored array (used for saving / loading from storage)
        this.ttl = options.ttl; // the time to persist this array for (in days)
        this.backend = Storage;

        this._state = this.load();
    }

    /** save the current state of the array **/


    (0, _createClass3.default)(StoredArray, [{
        key: 'save',
        value: function save() {
            this.backend.set(this.key, (0, _stringify2.default)(this._state), { expires: this.ttl });
        }
    }, {
        key: 'load',
        value: function load() {
            return this.backend.get(this.key, true) || [];
        }
    }, {
        key: 'concat',
        value: function concat(otherArr) {
            var combined = this._state.concat(otherArr);
            this.save();

            return combined;
        }
    }, {
        key: 'push',
        value: function push(el) {
            this._state.push(el);
            this.save();
        }
    }, {
        key: 'pop',
        value: function pop() {
            var top = this._state.pop();
            this.save();

            return top;
        }
    }]);
    return StoredArray;
}();

exports.Storage = Storage;
exports.StoredArray = StoredArray;


//////////////////
// WEBPACK FOOTER
// ./~/@morgan-morgan/core/module/lib/storage.js
// module id = 86
// module chunks = 2 3